import { useEffect } from "react";

import { Link } from "react-router-dom";
import AttestationServicess from "./AttestationServicess";
import CODs from "./CODs";
import ColdChains from "./ColdChains";
import Distributions from "./Distributions";
import EcomSolutions from "./EcomSolutions";
import EconomyExpresss from "./EconomyExpresss";
import ExpressFlyers from "./ExpressFlyers";
import LiquidShippings from "./LiquidShippings";
import MehfoozExpresss from "./MefoozExpresss";
import MMSs from "./MMSs";
import OverlandExpresss from "./OverlandExpresss";
import OverNight from "./OverNights";
import PackNGOs from "./PackNGOs";

import PaymentSolutions from "./PaymentSolutions";
import RedBoxs from "./RedBoxs";
import SameDayDelivery from "./SameDayDeliverys";
import SecondDayDeliverys from "./SecondDayDeliverys";
import ShipmentInsurances from "./ShipmentInsurances";
import StudentExpresss from "./StudentExpresss";
import TCSFreshs from "./TCSFreshs";
import TicketingServicess from "./TicketingServicess";
import TimeChoiceDeliverys from "./TimeChoiceDeliverys";
import Warehouses from "./Warehouses";

const DomesticExpress = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false,
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false,
  );
  return (
    <div>
      <div id="international" className="">
        <img
          src="/DomesticScrollingBanner/main-banner.jpg"
          alt=""
          className="w-[100%]"
        />
      </div>

      <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
        <p>
          Our domestic operations are what makes us the leader in Pakistan’s
          courier and logistics industry. Facilitating walk-in customers at our
          Express Centres across Pakistan, we cater for the largest customer
          base in the country, with an endless range of cost-effective solutions
          for our customers, from domestic and international shipments of
          documents and parcels, to document attestation, visa dropbox,
          branchless banking, fulfilment services and everything in-between. Our
          round the clock domestic operations with retail teams, the largest
          delivery fleet and our service standards give our individual and
          business customers peace of mind while setting the bar for all courier
          and logistics companies in Pakistan.
        </p>

        <div className="MuiFormGroup-root MuiFormGroup-row">
          <div className="lg:flex grid pb-[50px]">
            <div className="flex-1 flex flex-col">
              <div className="flex items-center ">
                <li>
                  <Link to="/domestic-express/overnight" className="font-bold">
                    Overnight Express
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link
                    to="/domestic-express/samedaydelivery"
                    className="font-bold"
                  >
                    Same Day Delivery
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link
                    to="/domestic-express/2nddaydelivery"
                    className="font-bold"
                  >
                    2nd Day Delivery
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/timechoicedelivery"
                    className="font-bold"
                  >
                    Time Choice Delivery
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic-express/redbox" className="font-bold">
                    RedBox
                  </Link>
                </li>
              </div>

              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/economyexpress"
                    className="font-bold"
                  >
                    Economy Express
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/distribution"
                    className="font-bold"
                  >
                    Distribution
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/Warehousing"
                    className="font-bold"
                  >
                    Warehousing
                  </Link>
                </li>
              </div>
            </div>

            <div className="flex-1 flex flex-col">
              <div className="flex items-center ">
                <li>
                  <Link
                    to="/domestic-express/expressflyer"
                    className="font-bold"
                  >
                    Express Flyer
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/mehfoozexpress"
                    className="font-bold"
                  >
                    Mehfooz Express
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link
                    to="/domestic-express/liquidshipping"
                    className="font-bold"
                  >
                    Liquid Shipments
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link
                    to="/domestic-express/studentexpress"
                    className="font-bold"
                  >
                    Students Express
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link
                    to="/domestic-express/attestationservices"
                    className="font-bold"
                  >
                    Attestation Services
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link
                    to="/domestic-express/ticketingservices"
                    className="font-bold"
                  >
                    Ticketing Services
                  </Link>
                </li>
              </div>

              <div className="flex items-center">
                <li>
                  <Link to="/domestic-express/pack-n-go" className="font-bold">
                    PackNGo
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/overlandexpress"
                    className="font-bold"
                  >
                    Overland Express
                  </Link>
                </li>
              </div>
            </div>

            <div className="flex-1 flex flex-col">
              <div className="flex items-center">
                <li>
                  <Link to="/domestic-express/retail_cod" className="font-bold">
                    Retail COD
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/paymentsolution"
                    className="font-bold"
                  >
                    Payment Solutions
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/shipmentinsurance"
                    className="font-bold"
                  >
                    Shipment Transit Insurance
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic-express/tcsfresh" className="font-bold">
                    TCS Fresh
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link
                    to="/domestic-express/ecomsolution"
                    className="font-bold"
                  >
                    E-com Solutions
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic-express/mms" className="font-bold">
                    Mailroom Management
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic-express/coldchain" className="font-bold">
                    Cold Chain Management
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-[2rem] md:mx-[0rem]">
        <div id="overnight">
          <OverNight />
        </div>
        <div id="samedaydelivery">
          <SameDayDelivery />
        </div>
        <div id="2nddaydelivery">
          <SecondDayDeliverys />
        </div>
        <div id="timechoicedelivery">
          <TimeChoiceDeliverys />
        </div>
        <div id="redbox">
          <RedBoxs />
        </div>
        <div id="economyexpress">
          <EconomyExpresss />
        </div>
        <div id="distribution">
          <Distributions />
        </div>
        <div id="Warehousing">
          <Warehouses />
        </div>
        <div id="expressflyer">
          <ExpressFlyers />
        </div>
        <div id="mehfoozexpress">
          <MehfoozExpresss />
        </div>
        <div id="liquidshipping">
          <LiquidShippings />
        </div>
        <div id="studentexpress">
          <StudentExpresss />
        </div>
        <div id="attestationservices">
          <AttestationServicess />
        </div>
        <div id="ticketingservices">
          <TicketingServicess />
        </div>
        <div id="pack-n-go">
          <PackNGOs />
        </div>
        <div id="overlandexpress">
          <OverlandExpresss />
        </div>
        <div id="retail_cod">
          <CODs />
        </div>
        <div id="paymentsolution">
          <PaymentSolutions />
        </div>
        <div id="shipmentinsurance">
          <ShipmentInsurances />
        </div>
        <div id="tcsfresh">
          <TCSFreshs />
        </div>
        <div id="ecomsolution">
          <EcomSolutions />
        </div>
        <div id="mms">
          <MMSs />
        </div>
        <div id="coldchain">
          <ColdChains />
        </div>
      </div>
    </div>
  );
};
export default DomesticExpress;
